
import CustomerList from './list.vue'
import CustomerEdit from "./edit.vue";

let a = Object.assign({CustomerList,CustomerEdit});
export default a;
